/*
 * Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';
import { ETransportPackageDTO } from './etransport-package-dto.model';
import { ETransportShipmentDocumentDTO } from './etransport-shipment-document-dto.model';

export class ETransportCommercialDataCollaborationDtoModel extends JSONable {
  eTransportNotificationUuid: string | null = null;
  operationTypeUuid: string | null = null;
  externalReference: string | null = null;
  fromCurrencyCode: string | null = null;
  fromExchangeRate: number | null = null;
  packageDTOs: ETransportPackageDTO[] = [];
  shipmentDocumentDTOs : ETransportShipmentDocumentDTO[] = [];
}
